import React, { useEffect, useRef, useState } from 'react';
import { Box, BoxProps, Button, Collapse, Stack } from '@mui/material';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { ISubTopic } from '../../../../store/SubTopicSlice';
import MarkdownRenderer from '../../../../helper/MarkdownRenderer/MarkdownRenderer';

const boxProps: BoxProps = {
  component: 'section',
  id: 'exam-tips',
  marginTop: '20px',
  marginBottom: '40px',
  sx: {
    borderRadius: '15px',
    border: '1px solid #DB86F8',
    background: '#F8FAFC',
  },
};

const divStyles = {
  height: '16px',
  borderRadius: '15px 15px 0px 0px ',
  background: 'linear-gradient(90deg, #DB86F8 0%, #006FD6 100%)',
};

const imageStyles: React.CSSProperties = {
  position: 'relative',
  width: '68px',
  top: '-25px',
  left: '15px',
};

interface IExamTipsProps {
  subTopicData: ISubTopic;
}

const ExamTips: React.FC<IExamTipsProps> = ({ subTopicData }) => {
  const ref = useRef<HTMLDivElement>(null);

  // State
  const [isExpand, setIsExpand] = useState(false);
  const [height, setHeight] = useState(0);

  const maxHeight = 308;

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientHeight);
    }
  });

  return (
    <Box {...boxProps}>
      <div style={divStyles}>
        <img
          src={`${process.env.PUBLIC_URL}/images/subtopicPage/bulb-icon.png`}
          alt="bulb-icon"
          style={imageStyles}
        />
      </div>
      <Box padding="20px 40px">
        <Collapse
          in={isExpand}
          collapsedSize={maxHeight > height ? height : maxHeight}
        >
          <div ref={ref}>
            {subTopicData.contents?.map((content) => (
              <div
                key={content._id}
                className={
                  content.details.includes('ql-indent')
                    ? 'view ql-editor ql-viewer ql-custom'
                    : ''
                }
              >
                <MarkdownRenderer content={content.details} />
              </div>
            ))}
          </div>
        </Collapse>
        {maxHeight < height && (
          <Stack alignItems="center">
            <Button
              color="inherit"
              endIcon={isExpand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              onClick={() => setIsExpand((prevState) => !prevState)}
              sx={{
                fontWeight: 600,
                marginTop: '10px',
              }}
            >
              View {isExpand ? 'less' : 'more'}
            </Button>
          </Stack>
        )}
      </Box>
    </Box>
  );
};

export default ExamTips;
